import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { AxiosInstance } from 'axios';

import { languageSlice } from './globalSlice/languageSlice/LanguageSlice';
import { listenerMiddleware } from './globalSlice/middlewareSlice';
import { onboardingSlice } from './globalSlice/onboardingSlice';
import { styleSlice } from './globalSlice/styleSlice';

import { userContractSlice } from './services/dashboardSlice/HomeUserSlice';
import { requestScreenSlice } from './services/requestScreen/RequestScreenSlice';
import { createApiInstance } from '../services/hooks/apiRedux';

const languageState = JSON.parse(localStorage.getItem('preferred_language') || 'null');
const preferredLanguage = { legalPersonalitySlug: 'en' };

const api = createApiInstance();

export const store = configureStore({
  preloadedState: {
    language: languageState === null ? preferredLanguage : languageState
  },
  reducer: {
    language: languageSlice.reducer,
    userContract: userContractSlice.reducer,
    requestScreen: requestScreenSlice.reducer,
    onboarding: onboardingSlice.reducer,
    styleGuide: styleSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: { api }
      }
    }).concat(listenerMiddleware.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, { api: AxiosInstance }, Action<string>>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppDispatchThunk: () => typeof store.dispatch = useDispatch;
